'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Content, Close, Portal } from './../../../external/@radix-ui/react-dialog/dist/index.js';
import { IconX } from '../../svg/icons/icon-x.js';
import { Button } from '../button/button.js';
import { ButtonSize } from '../button/constants.js';

const TakeoverModalContent = ({ children, preventCloseOnOverlayClick, preventScroll = false }) => {
    const content = (jsxs(Content, { className: "fixed left-0 top-0 flex size-full flex-col overflow-hidden bg-leland-gray-hover/50 backdrop-blur-3xl", onPointerDownOutside: preventCloseOnOverlayClick ? (e) => e.preventDefault() : undefined, onEscapeKeyDown: preventCloseOnOverlayClick ? (e) => e.preventDefault() : undefined, onFocusCapture: (e) => {
            e.stopPropagation(); // prevent auto-focus of internal elements when the modal is opened
        }, children: [jsx(Close, { className: "absolute right-2 top-2", children: jsx(Button, { label: "X", hideLabel: true, LeftIcon: IconX, size: ButtonSize.MEDIUM, rounded: true }) }), jsx("div", { className: "flex size-full items-center justify-center", children: jsx("div", { className: `max-h-[90%] max-w-md ${preventScroll ? 'overflow-hidden' : 'overflow-auto'}`, children: children }) })] }));
    return jsx(Portal, { children: content });
};

export { TakeoverModalContent };
//# sourceMappingURL=takeover-modal.js.map
